import { Lightning, Router } from "@lightningjs/sdk";
import { Card } from "./Card";
import { FOCUS_TRANSITION, UNFOCUSED_ROW_ALPHA } from "./focus";
export class Banner extends Lightning.Component {
    constructor() {
        super(...arguments);
        this._cornerRadius = Card.BORDER_R;
        this._href = "";
        this._aspectRatio = 0;
    }
    static _template() {
        return {
            alpha: UNFOCUSED_ROW_ALPHA,
            // Keep the image in the render tree until its natural size is available.
            h: 1,
            w: this.W,
            PosterContainer: {
                h: (h) => h,
                w: (w) => w,
                color: 0x00000000,
                rect: true,
                shader: {
                    type: Lightning.shaders.RoundedRectangle,
                    radius: Card.BORDER_R,
                },
                Poster: {
                    h: (h) => h,
                    w: (w) => w,
                    texture: { type: Lightning.textures.ImageTexture },
                },
                Border: {
                    alpha: 0,
                    color: Card.BORDER_COLOR,
                },
            },
        };
    }
    _init() {
        const poster = this.tag("PosterContainer.Poster");
        const resize = (texture) => {
            this._aspectRatio = texture.getRenderWidth() / texture.getRenderHeight();
            this.updateDimensions();
        };
        poster.on("txLoaded", resize);
        // Cached images can already be loaded before the component is initialised.
        if (poster.textureIsLoaded())
            resize(poster.texture);
    }
    set item(item) {
        var _a;
        this._href = (_a = item.href) !== null && _a !== void 0 ? _a : "";
        this.tag("PosterContainer.Poster").patch({ src: item.posterSrc });
    }
    set cornerRadius(radius) {
        this._cornerRadius = radius;
        this.tag("PosterContainer").patch({ shader: { radius } });
        this.updateDimensions();
    }
    _focus() {
        this.setSmooth("alpha", 1, FOCUS_TRANSITION);
        this.tag("PosterContainer.Border").setSmooth("alpha", 1, FOCUS_TRANSITION);
    }
    _unfocus() {
        this.setSmooth("alpha", UNFOCUSED_ROW_ALPHA, FOCUS_TRANSITION);
        this.tag("PosterContainer.Border").setSmooth("alpha", 0, FOCUS_TRANSITION);
    }
    _handleEnter() {
        if (this._href)
            Router.navigate("video", { href: this._href });
        return true;
    }
    updateDimensions() {
        if (!this._aspectRatio)
            return;
        this.h = this.w / this._aspectRatio;
        this.tag("PosterContainer.Border").patch({
            texture: Card.borderTexture(this.w, this.h, this._cornerRadius),
        });
    }
}
Banner.W = 1690;
export default Banner;
//# sourceMappingURL=Banner.js.map